import { Button, Dialog, DialogBody, DialogFooter } from '@blueprintjs/core'

export function AboutDialog({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="About AMATL"
      icon="info-sign"
    >
      <DialogBody>
        <p>
          <b>AMATL</b> — Advanced Metal Additive Toolpath Library.
        </p>
        <p>Robotic hardfacing / welding offline-programming:</p>
        <ul>
          <li>STEP ingest and face classification (OCCT)</li>
          <li>Cone-helix / flank-helix cladding, surface-intersection seams</li>
          <li>Analytical IK (compas_fab, ABB IRB 4600 + 2-axis positioner)</li>
          <li>FCL per-frame clash detection + OCCT exact clearance report</li>
          <li>ABB RAPID (.mod) emit</li>
        </ul>
        <p className="tree-dim">
          © SORS International — v2 React / FastAPI shell.
        </p>
      </DialogBody>
      <DialogFooter
        actions={
          <Button onClick={onClose} intent="primary">
            Close
          </Button>
        }
      />
    </Dialog>
  )
}
